import { render, staticRenderFns } from "./discussNotice.vue?vue&type=template&id=2c9aed4a&scoped=true&"
import script from "./discussNotice.vue?vue&type=script&lang=js&"
export * from "./discussNotice.vue?vue&type=script&lang=js&"
import style0 from "./discussNotice.vue?vue&type=style&index=0&id=2c9aed4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9aed4a",
  null
  
)

export default component.exports